module.exports = __webpack_public_path__ + "static/media/vf_wdress_no_waist_no_style_core.94ec71ef.svg";